import { ContactService } from './../../../api/contact.service';
import { GtagService } from './../../../analytics/gtag.service';
import { FbqService } from './../../../analytics/fbq.service';
import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { Contact, FormError } from '../../../models/index';
import { environment } from './../../../../../environments/environment';
import { AgencyService } from '../../../api/agency.service';
import { ReCaptchaComponent } from '../../../re-captcha.component'

@Component({
  selector: 'app-contact-form-base',
  templateUrl: './contact-form-base.component.html',
  styleUrls: ['./contact-form-base.component.scss']
})

export class ContactFormBaseComponent implements OnInit {
  @Input() title: {};
  @Input() prependMessage: {};
  @Input() propertyId: string | number;
  @Input() apartmentTypeId: string | number;
  @Input() projectId: number;
  @ViewChild('reCaptcha') reCaptcha: ReCaptchaComponent;
  submitInProgress: boolean;
  success: boolean;
  contact: Contact = new Contact();
  formError: FormError = new FormError();
  canShowErrors: boolean = false;

  get reCaptchaVersion(): string {
    return environment.re_captcha_version;
  }

  constructor(
    public contactService: ContactService,
    public gtagService: GtagService,
    public fbqService: FbqService,
    public agencyService: AgencyService
  ) { }

  ngOnInit(): void {
    this.success = false;
    this.submitInProgress = false;
  }

  onSubmit(): void {
    this.canShowErrors = true;

    if (this.submitInProgress || this.success)
      return;

    if (!this.contact.marketing_accepted) {
      this.formError.errors.marketing_accepted = 'pentru a trimite un mesaj, această bifă este obligatorie.';
      return;

    } else
      this.formError.errors.marketing_accepted = null;

    this.formError = new FormError();

    this.contact.re_captcha_version = this.reCaptchaVersion

    this.sendMessage();
  }

  onCaptchaResponse(response: string): void {
    this.contact['g-recaptcha-response'] = response;

    if (this.reCaptchaVersion === 'v2_invisible')
      this.sendMessage();
  }

  sendMessage(): void {
    let promise;

    if (this.submitInProgress)
      return;

    this.submitInProgress = true;

    const contact = JSON.parse(JSON.stringify(this.contact));
    if (this.prependMessage)
      contact.message = this.prependMessage + '\n\n\n' + (this.contact.message ? this.contact.message : '');

    if (this.propertyId) {
      promise = this.contactService.sendToProperty(this.propertyId, contact);
    } else if (this.projectId) {
      promise = this.contactService.sendToProject(this.projectId, contact);
    } else if (this.apartmentTypeId) {
      promise = this.contactService.sendToApartmentType(this.apartmentTypeId, contact);
    } else {
      promise = this.contactService.sendToAgency(contact);
    }

    if (promise) {
      promise
        .then(response => {
          this.contact = new Contact();
          this.submitInProgress = false;
          this.success = true;

          this.gtagService.sendEvent('contact', 'message_sent', 'contact_form_sent');
          this.fbqService.sendEvent('Lead', { content_name: 'contact_form_sent', content_category: 'message_sent' });
        })
        .catch(reposnse => {
          this.formError = reposnse;
          this.submitInProgress = false;
          this.success = false;
        });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/common-theme/base-components/shared/contact-form-base/contact-form-base.component.ts